var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66659 33.3332C5.74992 33.3332 4.96547 33.0071 4.31325 32.3548C3.66103 31.7026 3.33436 30.9176 3.33325 29.9998V9.99984C3.33325 9.08317 3.65992 8.29873 4.31325 7.6465C4.96659 6.99428 5.75103 6.66762 6.66659 6.6665H33.3333C34.2499 6.6665 35.0349 6.99317 35.6883 7.6465C36.3416 8.29984 36.6677 9.08428 36.6666 9.99984V29.9998C36.6666 30.9165 36.3405 31.7015 35.6883 32.3548C35.036 33.0082 34.251 33.3343 33.3333 33.3332H6.66659ZM19.9999 21.6665L33.3333 13.3332V9.99984L19.9999 18.3332L6.66659 9.99984V13.3332L19.9999 21.6665Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.3867e9c90360c7b26bd575a988e2a212.svg";
export { ForwardRef as ReactComponent };